<button
  type="button"
  class="wrapper--container"
  nxPlainButton
  #clickTriggerIcon
  [nxPopoverTriggerFor]="popoverClick"
  (nxPopoverShowChange)="onShowChange($event)"
  nxPopoverTrigger="click"
  tabindex="0"
  role="button"
  nxPopoverDirection="right"
>
  <nx-icon name="info-circle-o"> </nx-icon>
  <nx-link>
    <span class="wrapper--icon"> </span>
  </nx-link>
</button>

<nx-popover #popoverClick>
  <div class="wrapper--text" *ngIf="popover.textTop">
    <p>{{ popover.textTop | translate }}</p>
  </div>
  <div class="wrapper--img" *ngIf="popover.figure">
    <figure nxFigure="1dot2by1">
      <img src="{{ popover.figure.img | translate }}" alt="{{ popover.figure.alt | translate }}" />
    </figure>
  </div>
  <div class="wrapper--text" *ngIf="popover?.textBottom">
    <p>{{ popover.textBottom ?? '' | translate }}</p>
  </div>
  <div class="wrapper--text" *ngIf="popover?.textHtml" [innerHTML]="popover.textHtml"></div>
</nx-popover>
